import React, { useState, createRef, useEffect } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useScreenshot } from "use-react-screenshot";
import CropEasy from "./Components/crop/CropEasy";
import { BsFillCloudUploadFill } from "react-icons/bs";
import Loader from "./Components/Loader";
import "./assets/style/index.css";
import PostGujaratiVadodara from "./Components/PostSVG/PostGujaratiVadodara";
import StoryGujaratiVadodara from "./Components/PostSVG/StoryGujaratiVadodara";

function Vadodara() {
  const [state, setState] = React.useState({ name: "", selectedOption: "EM" });
  const [isLoading, setIsLoading] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const ref = createRef(null);
  const [fileMain, setFileMain] = React.useState(null);
  const [fileSide, setFileSide] = React.useState(null);
  const [photoURLSide, setPhotoURLSide] = React.useState();
  const [photoURLMain, setPhotoURLMain] = React.useState();

  const [photoMain, setPhotoMain] = React.useState();
  const [photoSide, setPhotoSide] = React.useState();
  const [type, setType] = useState("");
  const [openCrop, setOpenCrop] = React.useState(false);
  const [isMobileScreen, setIsMobileScreen] = React.useState(false);
  const [screenshotCount, setScreenshotCount] = useState(0);
  const [showHiddenDiv, setShowHiddenDiv] = useState(false);

  const handleMainChange = async (e) => {
    const file = e.target.files[0];
    setType("Main");
    if (file) {
      setOpenCrop(true);
      setFileMain(file);
      setPhotoURLMain(URL.createObjectURL(file));
    }
  };

  const [image, takeScreenShot] = useScreenshot({
    type: "image/png",
    quality: 10,
  });

  const downloadScreenshot = async () => {
    setIsLoading(true);
    setShowHiddenDiv(true);
    setScreenshotCount((prev) => prev + 1);
    await takeScreenShot(ref.current)
      .then((image) => {
        if (screenshotCount === 1) {
          const link = document.createElement("a");
          link.href = image;
          link.download = `${state.category}`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setScreenshotCount(0);
          setShowHiddenDiv(false);
        }
      })
      .catch((error) => {
        console.error("Error while taking screenshot:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (screenshotCount === 1 && showHiddenDiv) {
      downloadScreenshot();
    }
  }, [screenshotCount, showHiddenDiv]);

  let isMobile = window.innerWidth < 500;

  useEffect(() => {
    if (isMobile) {
      setIsMobileScreen(true);
    }
  }, [isMobile]);

  return (
    <>
      {openCrop ? (
        <CropEasy
          {...{
            photoURLSide,
            photoURLMain,
            setOpenCrop,
            setPhotoURLSide,
            setPhotoURLMain,
            setFileSide,
            setFileMain,
            setPhotoMain,
            setPhotoSide,
            type,
          }}
        />
      ) : (
        <div className="App">
          {loading && <Loader />}
          <div className="nav w-100 header-sticky">
            <h2 className="nav_head">Webito Infotech Invitation</h2>
          </div>
          <Container style={{ backgroundColor: "white" }}>
            <Row>
              <Col className="col-12 col-md-6 form_main mb-5">
                <Form className="form_data">
                  <Form.Group className="mt-3 form_C form_name">
                    <Form.Label>Select</Form.Label>
                    <Form.Select
                      name="category"
                      value={state?.category || ""}
                      onChange={(e) =>
                        setState({ ...state, category: e.target.value })
                      }
                    >
                      <option value="">-- Select an option --</option>
                      <option value="post_vadodara">Post Vadodara</option>
                      <option value="story_vadodara">Story Vadodara</option>
                    </Form.Select>
                  </Form.Group>
                  <Form.Group className="mt-3 form_C form_name">
                    <Form.Label>First Name:</Form.Label>
                    <Form.Control
                      type="text"
                      onChange={(e) => {
                        setState({
                          ...state,
                          firstName: e.target.value?.toUpperCase(),
                        });
                      }}
                      name="firstName"
                      value={state?.firstName}
                      placeholder="Enter the first name"
                    />
                  </Form.Group>
                  <Form.Group className="mt-3 form_C form_upload">
                    <Form.Control
                      className="d-none"
                      type="file"
                      accept=".jpg,.jpeg,.png"
                      id="myfile"
                      name="myfile"
                      onChange={handleMainChange}
                    />
                    <label for="myfile" className="file_upload">
                      <h1>Upload Profile Pic</h1>
                      <div>
                        <p>
                          Click on the upload icon to upload profile pic. You
                          can repeat this step to choose another profile pic.
                        </p>
                        <div className="box_icon">
                          <BsFillCloudUploadFill />
                        </div>
                      </div>
                    </label>
                  </Form.Group>
                  <Button
                    type="button"
                    className="mt-3 form_button"
                    style={{
                      backgroundColor: "#0c6566",
                      borderColor: "#0c6566",
                    }}
                    onClick={() => downloadScreenshot()}
                    disabled={isLoading || !state.category}
                  >
                    {isLoading ? "Loading......" : "Download"}
                  </Button>
                </Form>
              </Col>
            </Row>
            <Col
              className="col-10 d-flex col-md-10"
              style={{
                marginTop: isMobileScreen ? "180px" : "0px",
              }}
            >
              <div ref={ref}>
                {state?.category === "post_vadodara" ? (
                  <PostGujaratiVadodara
                    fileMain={photoMain}
                    fileSide={photoSide}
                    firstName={state.firstName}
                    companyName={state.companyName}
                  />
                ) : state?.category === "story_vadodara" ? (
                  <StoryGujaratiVadodara
                    fileMain={photoMain}
                    fileSide={photoSide}
                    firstName={state.firstName}
                    companyName={state.companyName}
                  />
                ) : (
                  ""
                )}
              </div>
            </Col>
          </Container>
        </div>
      )}
    </>
  );
}

export default Vadodara;
